import { render } from "./App.vue?vue&type=template&id=7059f439&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.css?vue&type=style&index=0&lang=css"

import exportComponent from "/var/www/myfeed.larodev.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__